// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2Kgrg","spinner":"styles_spinner__2wZUb","preloader":"styles_preloader__15bxQ"};